import { getHreflangByI18nKey } from 'components/DocumentHead/helpers'
import { TranslateFnType } from 'store'
import { StaticPages } from 'store/pages/static/types'
import {
  OriginByLocaleMapType,
  TranslatedUrlsType,
} from 'store/urlManager.store'
import { LocaleType } from 'types/locale'

export function getStaticPageSeo(
  page: StaticPages,
  t: TranslateFnType,
  originByLocaleMap: OriginByLocaleMapType,
  translatedUrlsPerLocale: TranslatedUrlsType,
  excludeLocales?: LocaleType[],
): {
  title: string
  links: any[]
  customTitleTemplate: boolean
} {
  switch (page) {
    case 'privacy':
      return {
        title: t('Datenschutz'),
        links: getHreflangByI18nKey({
          key: 'datenschutz_url',
          originByLocaleMap,
          translatedUrlsPerLocale,
          excludeLocales,
        }),
        customTitleTemplate: false,
      }

    case 'faq':
      return {
        title: t('Häufige Fragen'),
        links: getHreflangByI18nKey({
          key: 'haeufige-fragen_url',
          originByLocaleMap,
          translatedUrlsPerLocale,
          excludeLocales,
        }),
        customTitleTemplate: false,
      }

    case 'agb':
      return {
        title: t('AGB'),
        links: getHreflangByI18nKey({
          key: 'agb_url',
          originByLocaleMap,
          translatedUrlsPerLocale,
          excludeLocales,
        }),
        customTitleTemplate: false,
      }

    case 'terms_of_use':
      return {
        title: t('Nutzungsbedingungen'),
        links: getHreflangByI18nKey({
          key: 'nutzungsbedingungen_url',
          originByLocaleMap,
          translatedUrlsPerLocale,
          excludeLocales,
        }),
        customTitleTemplate: false,
      }

    case 'imprint':
      return {
        title: t('Impressum'),
        links: getHreflangByI18nKey({
          key: 'impressum_url',
          originByLocaleMap,
          translatedUrlsPerLocale,
          excludeLocales,
        }),
        customTitleTemplate: false,
      }

    case 'voucher_conditions':
      return {
        title: t('ABOUT YOU Gutscheine und Gutscheinbedingungen'),
        links: [],
        customTitleTemplate: true,
      }

    default:
      return {
        title: '',
        links: [],
        customTitleTemplate: false,
      }
  }
}
